export enum Feature {
  Dashboard = "CCAU.Dashboard",
  Gradebook_Entries_All = "CCAU.Gradebook.Entries.All",
  Gradebook_My_Entries = "CCAU.Gradebook.My_Entries",
  Gradebook_Entries_Grade = "CCAU.Gradebook.CCAU.Gradebook.Entries.Grade",
  Gradebook_Entries_Submit = "CCAU.Gradebook.Entries.Submit",
  Gradebook_Entries_Reset = "CCAU.Gradebook.Entries.Reset",
  Requests = "CCAU.Requests",
  Requests_Pending = "CCAU.Requests.Pending",
  Requests_Pending_ChangeStatus = "CCAU.Requests.Pending.ChangeStatus",
  Requests_Resolved = "CCAU.Requests.Resolved",
  Learning_MyCourses = "CCAU.Learning.MyCourses",
  Learning_MyCourses_Active__Upcoming__Past = "CCAU.Learning.MyCourses.Active_Upcoming_Past",
  Learning_Courses = "CCAU.Learning.Courses",
  Learning_Courses_Active__Inactive = "CCAU.Learning.Courses.Active_Inactive",
  Learning_Course = "CCAU.Learning.Course",
  Learning_Course_Details = "CCAU.Learning.Course.Details",
  Learning_Course_MyDetails = "CCAU.Learning.Course.MyDetails",
  Learning_Course_Details_Progress = "CCAU.Learning.Course.Details_Progress",
  Learning_Course_Syllabus = "CCAU.Learning.Course.Syllabus",
  Learning_Course_Resources = "CCAU.Learning.Course.Resources",
  Learning_Course_Outline = "CCAU.Learning.Course.Outline",
  Learning_Course_Progress = "CCAU.Learning.Course.Progress",
  Learning_Course_AssignedLearners = "CCAU.Learning.Course.AssignedLearners",
  Learning_Course_UngradedWorks = "CCAU.Learning.Course.UngradedWorks",
  Learning_Course_Learners_Assign = "CCAU.Learning.Course.Learners.Assign",
  Learning_Course_Learners_Unassign = "CCAU.Learning.Course.Learners.Unassign",
  Hangfire_Dashboard = "CCAU.Hangfire.Dashboard",
  CourseManagementLearn = "courseManagement__learn",
  CourseManagementGradeAll = "courseManagement__grade__all",
  CourseManagementGradeAssigned = "courseManagement__grade__assigned",
  CourseManagementReadAll = "courseManagement__read__all",
  CourseManagementReadAssigned = "courseManagement__read__assigned",
  CourseManagementTemplate = "courseManagment__template",
  CourseManagementAssignUser = "courseManagment__assignUser",
  CourseManagementGradeView = "courseManagement__grade__view",
}
